import {
    SHOP_THE_LOOK_GET_REQUEST,
    SHOP_THE_LOOK_GET_SUCCESS,
    SHOP_THE_LOOK_GET_ERROR,
    UPDATE_LAST_SELECTED_COLOR,
} from '../actionTypes/ShopTheLookActionTypes';

const defaultState = {
    lastSelectedColor: '',
    productPrices: [],
    error: null,
};

function ShopTheLookReducer(state = defaultState, action) {
    switch (action.type) {
        case UPDATE_LAST_SELECTED_COLOR:
            return {
                ...state,
                lastSelectedColor: action.lastSelectedColor,
            };
        case SHOP_THE_LOOK_GET_SUCCESS:
            return {
                ...state,
                productPrices: action.payload,
            };
        case SHOP_THE_LOOK_GET_ERROR:
            return {
                ...state,
                error: action.error,
            };
        case SHOP_THE_LOOK_GET_REQUEST:
        default:
            return state;
    }
}

export default ShopTheLookReducer;
